import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { HouseholdStoreService, StoreService } from '@se-po/se-household-setup-data-access-store'
import {
  SeHouseholdSetupFeatureChildContactInfoModule
} from '@se-po/se-household-setup-feature-child-contact-info'
import {
  SeHouseholdSetupFeatureChildInfoModule
} from '@se-po/se-household-setup-feature-child-info'
import { SeHouseholdSetupFeatureInviteModule } from '@se-po/se-household-setup-feature-guardian-invite'
import {
  SeHouseholdSetupFeatureParentGuardianInfoModule
} from '@se-po/se-household-setup-feature-parent-guardian-info'
import { SeHouseholdSetupFeatureReviewModule } from '@se-po/se-household-setup-feature-review'
import {
  SeHouseholdSetupFeatureSelfInfoModule
} from '@se-po/se-household-setup-feature-self-info'
import {
  SeHouseholdSetupFeatureWhosParticipatingModule
} from '@se-po/se-household-setup-feature-whos-participating'
import { SharedUiSetupBarModule } from '@se-po/shared-ui-setup-bar'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeLinkModule } from 'se-fe-link'

import { CreateHouseholdRoutingModule } from './create-household-routing.module'
import { CreateHouseholdComponent } from './create-household.component'

@NgModule({
  declarations: [
    CreateHouseholdComponent,
  ],
  imports: [
    CommonModule,
    CreateHouseholdRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeCardModule,
    SeFeLinkModule,
    SeHouseholdSetupFeatureChildContactInfoModule,
    SeHouseholdSetupFeatureChildInfoModule,
    SeHouseholdSetupFeatureInviteModule,
    SeHouseholdSetupFeatureReviewModule,
    SeHouseholdSetupFeatureParentGuardianInfoModule,
    SeHouseholdSetupFeatureSelfInfoModule,
    SeHouseholdSetupFeatureWhosParticipatingModule,
    SharedUiSetupBarModule,
    TranslateModule.forChild()
  ],
  exports: [],
  providers: [
    {
      provide: StoreService,
      useClass: HouseholdStoreService,
    },
  ]
})
export class CreateHouseholdModule {}
